export default __webpack_public_path__ + "static/media/FP_FR_GR.0d646e2d.png";